//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 import { GameMode, MAX_MULTIPLIERS ,GameStatus , BetType  } from './enum'; 

export default {
  name: 'BetCreatorComponent',
  props: {
    // 登录状态
    isAuthenticated: {
      type: Boolean,
      default: false
    },
    // 当前游戏对象
    currentGame: {
      type: Object,
      default: null
    },
    // 是否正在创建游戏
    isCreatingGame: {
      type: Boolean,
      default: false
    },
    // 是否正在下下一步
    isMakingStep: {
      type: Boolean,
      default: false
    },
    // 是否正在播放动画
    isAnimating: {
      type: Boolean,
      default: false
    },
    // 是否可以走下一步
    canMakeStep: {
      type: Boolean,
      default: true
    },
    // 是否可以创建游戏
    canCreateGame: {
      type: Boolean,
      default: true
    },
    // 下注类型: 'BALANCE' | 'INVENTORY'
    betType: {
      type: String,
      default: BetType.BALANCE
    },
    // 余额下注金额
    betAmountUsd: {
      type: Number,
      default: 0
    },
    // 选中的皮肤 ID 列表
    selectedIds: {
      type: Array,
      default: () => []
    },
    // 选中皮肤的总价值
    selectedInventoryAmountUsd: {
      type: Number,
      default: 0
    },
    // 余额检查函数，返回 boolean
    checkBalanceHandler: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      MIN_BET_AMOUNT_USD: 0.25
    };
  },
  computed: {
    // 是否处于加载/动画状态
    isLoading() {
      return this.isCreatingGame || this.isMakingStep || this.isAnimating;
    },

    // 按钮禁用状态逻辑
    isDisabled() {
      // 未登录时按钮保持可选，以便点击打开登录弹窗
      if (!this.isAuthenticated) {
        return false;
      }

      // 如果正在加载或播放动画则禁用
      if (this.isLoading) {
        return true;
      }

      // 游戏中状态
      if (this.currentGame && this.currentGame.status === GameStatus.IN_PROGRESS) {
        return !this.canMakeStep;
      }

      // 余额下注检查
      if (this.betType === BetType.BALANCE) {
        if (!this.betAmountUsd || this.betAmountUsd <= 0) {
          return true;
        }
      }

      // 库存/皮肤下注检查
      if (this.betType === BetType.INVENTORY) {
        if (!this.selectedIds || this.selectedIds.length === 0) {
          return true;
        }
      }

      return !this.canCreateGame;
    },

    // 按钮文案逻辑
    buttonText() {
      if (!this.isAuthenticated) {
        return '立即登录'; // 授权 / 登录
      }

      if (this.isCreatingGame || this.isMakingStep) {
        return '跳跃'; // 下一步
      }

      if (this.currentGame && this.currentGame.status === GameStatus.IN_PROGRESS) {
        return '跳跃'; // 下一步
      }

      if (this.currentGame && this.currentGame.status === GameStatus.LOST) {
        return '再玩一次'; // 再玩一次
      }

      return '开始游戏'; // 开始游戏
    }
  },
  methods: {
    // 核心下注/操作入口
    placeBet() {
      // 未登录时触发登录弹窗
      if (!this.isAuthenticated) {
        this.$emit('open-login');
        return;
      }

      if (this.isDisabled) {
        return;
      }

      // 游戏中：进行下一步
      if (this.currentGame && this.currentGame.status === GameStatus.IN_PROGRESS) {
        this.$emit('make-step');
        return;
      }

      // 新游戏开局前检查余额
      if (
        !this.currentGame ||
        this.currentGame.status === GameStatus.WON ||
        this.currentGame.status === GameStatus.LOST
      ) {
        if (this.checkBalanceHandler && !this.checkBalanceHandler()) {
          return;
        }
      }

      // 开始新游戏
      this.startNewGame();
    },

    startNewGame() {
      // 如果上一局已结束，重置上一局游戏数据
      if (
        this.currentGame &&
        (this.currentGame.status === GameStatus.WON || this.currentGame.status === GameStatus.LOST)
      ) {
        this.$emit('reset-game');
      }

      // 余额模式下注
      if (this.betType === BetType.BALANCE) {
        if (!this.betAmountUsd || this.betAmountUsd <= 0) {
          return;
        }

        if (this.betAmountUsd < this.MIN_BET_AMOUNT_USD) {
          this.$emit(
            'notify-error',
            '参与低于最低限额。最低金额：0.25'
          );
          return;
        }

        this.$emit('create-game');
      }
      // 皮肤/库存模式下注
      else if (this.betType === BetType.INVENTORY) {
        if (!this.selectedIds || this.selectedIds.length === 0) {
          return;
        }

        if (this.selectedInventoryAmountUsd < this.MIN_BET_AMOUNT_USD) {
          this.$emit(
            'notify-error',
            '参与低于最低限额。最低金额：0.25'
          );
          return;
        }

        this.$emit('create-game');
      }
    }
  }
};
